import React, { Component } from 'react';
export default  class Resume extends Component {
  render() {
    let resumeData = this.props.resumeData;
    function getResume(){
      window.location.href="https://drive.google.com/file/d/1KuofYVcj9EpYSdjqe71L3YQGbZ5Qp9MI/view?usp=sharing";
    }
    return (
      <section id="resume">

         <div className="row education">

            <div className="three columns header-col">
               <h1><span>Education</span></h1>
            </div>

            <div className="nine columns main-col" >
              {
                resumeData.education && resumeData.education.map((item)=>{
                  return(
                    <div className="row item" key={item.UniversityName}>
                       <div className="twelve columns">
                          <h3>{item.UniversityName}</h3>
                          <p className="info">
                          {item.specialization}
                          <span>&bull;</span> <em className="date">{item.MonthOfPassing} {item.YearOfPassing}</em></p>
                          <p>
                          {item.Achievements}
                          </p>
                       </div>
                    </div>
                  )
                })
              }
            </div>
         </div>
        <div style={{margin: "auto" , textAlign: "center"}}>
          <button onClick={()=>{getResume()}}>RESUME</button>
        </div>


         
   	


      </section>
    );
  }
}